module.exports = __webpack_public_path__ + "img/index_zhu_map.73535b9e.jpg";